<nav class="navbar navbar-expand-xl">
  <a
    class="nav-item nav-link"
    routerLink="/auth"
    style="margin-right: 80px"
    style="color: #f8f9fb"
    >Patent Chest&reg;</a
  >

  <a
    class="nav-item nav-link"
    routerLink="/auth"
    *ngIf="!logged"
    style="color: #f8f9fb"
    >Kullanıcı Girişi
  </a>
  <a
    class="nav-item nav-link"
    routerLink="/saveInvention"
    *ngIf="logged"
    style="color: #f8f9fb"
    >Buluş Kaydet</a
  >
  <a
  class="nav-item nav-link"
  routerLink="/searchCombo"
  *ngIf="logged"
  style="color: #f8f9fb"
  >Kriterler Üzerinden Ara</a
>
  <a
    class="nav-item nav-link"
    routerLink="/critical"
    *ngIf="logged"
    style="color: #f8f9fb"
    >Süreli İşler</a
  >

  <a
    class="nav-item nav-link"
    routerLink="/otherjobs"
    *ngIf="logged"
    style="color: #f8f9fb"
    >Diğer İşler(FTO/TBD..)</a
  >
  <a class="nav-item nav-link" routerLink="/bbf" style="color: #f8f9fb"
    >Formlar</a
  >
  <a
    class="nav-item nav-link"
    routerLink="/masterData"
    *ngIf="logged"
    style="color: #f8f9fb"
    >Veri Merkezi</a
  >

  <button
    (click)="logOut()"
    class="nav-item navbar"
    routerLink="/logout"
    *ngIf="logged"
    style="color: #f8f9fb"
  >
    Çıkış
  </button>
</nav>
